/**
 * Route for `goal-progress-widget`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { GoalProgressWidgetPage } from "../features/goal-progress-widget/GoalProgressWidgetPage";

export const goalProgressWidgetRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/goal-progress-widget",
	component: GoalProgressWidgetPage,
});

export default goalProgressWidgetRoute;
